//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicasTalcaGerencial } from "@/typings/store/plugins/easyFirestore/cajaChicasTalcaGerencial";

const getters: GetterTree<StateCajaChicasTalcaGerencial, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const cajaChicasTalcaGerencial = {
  firestorePath: "dev/v1/cajaChicasTalcaGerencial",
  firestoreRefType: "collection",
  moduleName: "cajaChicasTalcaGerencial",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default cajaChicasTalcaGerencial;
